export class WorkloadManagerDataService {
    public static getWorkloadPurchasers(callback: (output: any) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/workload/purchasers-list`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static updateAssignedPurchaser(docHeaderId, assignedPurchaserId : string | undefined, callback: (output: any) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/workload/docheader/${docHeaderId}/assign/${assignedPurchaserId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static getMyWorkloadCount(callback: (output: any) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/workload/my-workload-count`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}